import React, { useEffect } from "react";

import {
  GET_ORDER_COORDINATOR,
  DOCUMENTS_URL,
  INVOICES_URL,
  APPROVALS_URL,
  CARGOX_URL,
} from "@API/APIRoutes";
import GenericOrderInfo from "../../GenericFullOrderInfo/GenericFullOrderInfo";
import useGetItem from "@Hooks/useGetItem";
import { useParams } from "react-router-dom";
import { useState } from "react";
import Box from "@mui/material/Box";
import LoadingComponent from "@Components/LoadingComponent/LoadingComponent";
import themeCreator from "@Themes/themeCreator";
import { decryptId } from "../../../Utils/SecurityFunctions";

const orderInfoConfig = {
  tabs: [
    {
      label: "Primitive Info",
      subsections: [
        {
          title: "General Identification & Status",
          width: "500px",
          mr: 6,
          pr: 6,
          fields: [
            { label: "State", field: "state" },
            { label: "Origin", field: "origin" },
            { label: "PO Number", field: "poNumber" },
            { label: "Hscode", field: "hsCode" },
            { label: "Relative Company", field: "relativeCompany" },
            {
              label: "Category",
              field: "category.categoryName",
              fieldId: "categoryId",
            },
            {
              label: "Materials",
              field: "materials.materialName",
              fieldId: "materialId",
            },
            { label: "Agent", field: "agent.agentName", fieldId: "agentId" },
            {
              label: "Planner",
              field: "planner.plannerName",
              fieldId: "plannerId",
            },
            {
              label: "Supplier",
              field: "supplier.supplierName",
              fieldId: "supplierId",
            },
            { label: "Way Of Shipping", field: "wayOfShipping" },
            { label: "Is Sample", field: "isSample" },
          ],
        },
        {
          title: "General Identification (Date & Time)",
          width: "500px",
          mr: 6,
          pr: 6,
          fields: [
            {
              label: "PFI Receival Date",
              field: "pfiReceivalDate",
              formatter: "date",
            },
          ],
        },
      ],
      editable: true,
    },
    {
      label: "Order Info",
      subsections: [
        {
          title: "Order Details",
          width: "500px",
          mr: 6,
          pr: 6,
          fields: [
            { label: "Acid Number", field: "acidNumber" },
            { label: "Gross Weight", field: "grossWeight" },
            { label: "Net Weight", field: "netWeight" },
            { label: "Port Of Arrival", field: "portOfArrival" },
            {
              label: "Shipping Line",
              field: "shippingLine.shippingLineName",
              fieldId: "shippingLineId",
            },
            { label: "20' Containers", field: "container20" },
            { label: "40' Containers", field: "container40" },
            { label: "Pallets", field: "pallets" },
            { label: "Boxes", field: "boxes" },
            { label: "Booking Number ", field: "bookingNumber" },
            { label: "Shipping Port", field: "shippingPort" },
            { label: "Shipping Country", field: "shippingCountry" },
            { label: "Loadability", field: "loadability", capitalText: true },
            { label: "Drums", field: "drums" },
            { label: "General Comment", field: "generalComment" },
          ],
        },
        {
          title: "Order Info (Date & Time)",
          width: "500px",
          mr: 6,
          pr: 6,
          fields: [
            {
              label: "Acid Creation Date",
              field: "acidCreationDate",
              formatter: "date",
            },
            {
              label: "Shipped Onboard Date",
              field: "shippedOnboardDate",
              formatter: "date",
            },
          ],
        },
      ],
      editable: true,
    },
    {
      label: "Form 4 Info",
      subsections: [
        {
          title: "Form 4 Details",
          width: "500px",
          mr: 6,
          pr: 6,
          fields: [
            {
              label: "Bank",
              field: "bank.bankName",
              fieldId: "bankId",
              capitalText: true,
            },
            { label: "PO Amount", field: "poAmount" },
            { label: "PO Currency", field: "poCurrency", capitalText: true },
            { label: "Maturity Type", field: "maturityType" },
            { label: "Maturity Period", field: "maturityPeriod" },
            { label: "BOL Number", field: "bolNumber" },
            { label: "Inco Term", field: "incoTerm", capitalText: true },
            { label: "Invoice Number", field: "invoiceNumber" },
            { label: "Invoice Amount", field: "invoiceAmount" },
            {
              label: "Invoice Currency",
              field: "invoiceCurrency",
              capitalText: true,
            },
            {
              label: "Transaction Type",
              field: "transactionType",
              capitalText: true,
            },
            { label: "Proceeded Manually ?", field: "proceededManually" },
            { label: "CORA ID", field: "coraId" },
            { label: "IDC Number", field: "idcNumber" },
            {
              label: "IDC Linkages",
              field: "linkageInvoiceNumbers.invoiceNumber",
              fieldId: "orderId",
            },
          ],
        },
        {
          title: "Form 4 Details (Date & Time)",
          width: "500px",
          fields: [
            {
              label: "Form4 Sending Date",
              field: "form4SendingDate",
              formatter: "date",
            },
            {
              label: "Form4 Receival Date",
              field: "form4ReceivalDate",
              formatter: "date",
            },
            {
              label: "Upload on Portal Date",
              field: "uploadOnPortalDate",
              formatter: "date",
            },
            {
              label: "Maturity Date",
              field: "maturityDate",
              formatter: "date",
            },
            { label: "BOL Date", field: "bolDate", formatter: "date" },
            { label: "Invoice Date", field: "invoiceDate", formatter: "date" },
            ,
            {
              label: "Authorization Date",
              field: "authorizationDate",
              formatter: "date",
            },
          ],
        },
      ],
      editable: true,
    },
    {
      label: "Order Specific Info",
      subsections: [
        {
          title: "Order Specific Details",
          width: "500px",
          mr: 6,
          pr: 6,
          fields: [
            { label: "Order Number", field: "orderNumber" },
            { label: "Pending On", field: "pendingOn" },
            { label: "FOD", field: "fod" },
            { label: "Customs Certificate", field: "customCertificate" },
            {
              label: "Storage Location",
              field: "storageLocation.locationName",
              fieldId: "locationId",
            },
            {
              label: "Warehouse",
              field: "warehouse.warehouseName",
              fieldId: "warehouseId",
            },
            { label: "IBD Number", field: "ibdNumber" },
            { label: "Bank Linkage", field: "bankLinkage" },
            { label: "Non Relevant", field: "nonRelevant" },
          ],
        },
        {
          title: "Order Specific Details (Date & Time)",
          width: "500px",
          fields: [
            { label: "Release Date", field: "releaseDate", formatter: "date" },
            {
              label: "Expected Release Date",
              field: "expectedReleaseDate",
              formatter: "date",
            },
            {
              label: "Expected Arrival Date",
              field: "expectedArrivalDate",
              formatter: "date",
            },
            {
              label: "Actual Arrival Date",
              field: "actualArrivalDate",
              formatter: "date",
            },
            {
              label: "Customs Approval Date",
              field: "customsApprovalDate",
              formatter: "date",
            },
            {
              label: "Customs Release Date",
              field: "customsReleaseDate",
              formatter: "date",
            },
            {
              label: "Warehouse Arrival Date",
              field: "warehouseArrivalDate",
              formatter: "date",
            },
            { label: "IBD Date", field: "ibdDate", formatter: "date" },
            { label: "Storage Date", field: "storageDate", formatter: "date" },
          ],
        },
      ],
      editable: true,
    },
    {
      label: "Documents & CargoXs",
      subsections: [
        {
          title: "Documents",
          type: "Documents",
          width: "300px",
          mr: 3,
          pr: 1,
        },
      ],
      preview: {
        title: "Preview Document",
        width: "40vw",
        placeholder: "Select a document to preview",
      },
      editable: true,
    },
    {
      label: "Approvals Section",
      subsections: [
        {
          title: "Approvals",
          type: "Approvals",
          width: "300px",
          mr: 3,
          pr: 1,
        },
      ],
      preview: {
        title: "Preview Approvals",
        width: "40vw",
        placeholder: "Select an Approval to preview",
      },
      editable: false,
    },
    {
      label: "Payments",
      subsections: [
        {
          title: "Payments",
          type: "Invoices",
          width: "300px",
          mr: 3,
          pr: 1,
        },
      ],
      preview: {
        title: "Preview Payments",
        width: "40vw",
        placeholder: "Select a Payment to preview",
      },
      editable: false,
    },
  ],
};

export default function Form4OrderInfoPage() {
  const orderId  = decryptId(useParams().orderId);
  const getItem = useGetItem();
  const [invoices, setInvoices] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const [orderdata, setOrderData] = useState(null);
  const [documents, setDocuments] = useState(null);
  const [approvals, setApprovals] = useState(null);
  const [cargoXs, setCargoXs] = useState(null);
  const theme = themeCreator();

  useEffect(() => {
    setIsLoading(true);

    const promises = [
      getItem(GET_ORDER_COORDINATOR, orderId),
      getItem(INVOICES_URL, orderId),
      getItem(DOCUMENTS_URL, orderId),
      getItem(APPROVALS_URL, orderId),
      getItem(CARGOX_URL, orderId),
    ];

    Promise.all(promises)
      .then(([orderData, invoices, documents, approvals, cargoXs]) => {
        setOrderData(orderData);
        setInvoices(invoices);
        setDocuments(documents);
        setApprovals(approvals);
        setCargoXs(cargoXs);
        setIsLoading(false);
      })
      .catch((error) => {
        setIsLoading(false);
      });
  }, [orderId]);

  if (isLoading) {
    return (
      <Box
        display="flex"
        justifyContent="center"
        alignItems="center"
        height={theme.pageHeight}
      >
        <LoadingComponent />
      </Box>
    );
  }

  return (
    <GenericOrderInfo
      orderId={orderId}
      orderData={orderdata}
      config={orderInfoConfig}
      invoices={invoices}
      approvals={approvals}
      cargoXs={cargoXs}
      documents={documents}
    />
  );
}
